import { _ as _define_property } from "@swc/helpers/_/_define_property";
export var PageLoadEvent;
(function(PageLoadEvent) {
    // These timings live in the html document
    PageLoadEvent["docStart"] = "docStart";
    PageLoadEvent["docPreData"] = "docPreData";
    PageLoadEvent["docDataStart"] = "docDataStart";
    PageLoadEvent["docDataEnd"] = "docDataEnd";
    PageLoadEvent["docVendorBundleStart"] = "docVendorBundleStart";
    PageLoadEvent["docMainBundleStart"] = "docMainBundleStart";
    PageLoadEvent["docMainBundleEnd"] = "docMainBundleEnd";
    PageLoadEvent["docEnd"] = "docEnd";
    // These timings live in the react app
    PageLoadEvent["appStart"] = "appStart";
    PageLoadEvent["appInitialized"] = "appInitialized";
    PageLoadEvent["firstPaint"] = "firstPaint";
    PageLoadEvent["pageStart"] = "pageStart";
    PageLoadEvent["pageInteractive"] = "pageInteractive";
    PageLoadEvent["primaryFetchStart"] = "primaryFetchStart";
    PageLoadEvent["primaryFetchEnd"] = "primaryFetchEnd";
    PageLoadEvent["firstMeaningfulPaint"] = "firstMeaningfulPaint";
    // These are durations, composed of timings above
    PageLoadEvent["durationParse"] = "durationParse";
    PageLoadEvent["durationFetchData"] = "durationFetchData";
    PageLoadEvent["durationDocData"] = "durationDocData";
    PageLoadEvent["durationVendorBundle"] = "durationVendorBundle";
    PageLoadEvent["durationMainBundle"] = "durationMainBundle";
    PageLoadEvent["durationFirstPaint"] = "durationFirstPaint";
    PageLoadEvent["durationRender"] = "durationRender";
})(PageLoadEvent || (PageLoadEvent = {}));
var _obj;
export var pageLoadDurations = (_obj = {}, _define_property(_obj, PageLoadEvent.durationParse, [
    PageLoadEvent.docStart,
    PageLoadEvent.docEnd
]), _define_property(_obj, PageLoadEvent.durationFetchData, [
    PageLoadEvent.docPreData,
    PageLoadEvent.docDataStart
]), _define_property(_obj, PageLoadEvent.durationDocData, [
    PageLoadEvent.docDataStart,
    PageLoadEvent.docDataEnd
]), _define_property(_obj, PageLoadEvent.durationVendorBundle, [
    PageLoadEvent.docVendorBundleStart,
    PageLoadEvent.docMainBundleStart
]), _define_property(_obj, PageLoadEvent.durationMainBundle, [
    PageLoadEvent.docMainBundleStart,
    PageLoadEvent.docMainBundleEnd
]), _define_property(_obj, PageLoadEvent.durationFirstPaint, [
    PageLoadEvent.appInitialized,
    PageLoadEvent.firstPaint
]), _define_property(_obj, PageLoadEvent.durationRender, [
    PageLoadEvent.appInitialized,
    PageLoadEvent.firstMeaningfulPaint
]), _obj);
